<template>
  <v-form ref="form_4">
    <v-container>
      <v-layout column>
        <v-flex xs12 class="mt-0 pa-0 pr-0 mr-0">
          <FlightSearchDescription :descriptions="descriptions" />
        </v-flex>
        <v-flex xs12>
          <v-container>
            <v-layout row wrap align-center>
              <v-flex xs12 sm6 class="pt-4 pl-4 pb-2">
                <h1>Passengers</h1>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink>
                <CountdownTimer />
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 class="px-4">
          <AddPassengerDetails />
        </v-flex>
      </v-layout>
    </v-container>
    <ShowErrors class="px-2 mr-4" />
    <v-container>
      <v-flex xs12 class="py-4">
        <v-layout class="px-10 justify-center" v-if="errors.length === 0">
          <v-btn
            @click="setPreviousStep(getFormIndexByPath('/passengers'))"
            class="accent_light"
          >
            <v-icon class="reverse">arrow_right_alt</v-icon>
            Previous
          </v-btn>
          <v-btn
            @click="setNextStep()"
            :disabled="!testCompleteStep(getFormIndexByPath('/passengers'))"
            class="accent"
          >
            Continue
            <v-icon>arrow_right_alt</v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-container>
  </v-form>
</template>

<script>
import store from "../../store";
import Shared from "@/mixins/Shared";
import BookingFormMixin from "@/mixins/BookingFormMixin";
import FlightSearchDescription from "@/components/forms/FlightSearchDescription.vue";
import CountdownTimer from "@/components/CountdownTimer.vue";
import ShowErrors from "@/components/pages/ShowErrors.vue";

export default {
  name: "FormPassengers",
  store: store,
  mixins: [BookingFormMixin, Shared],
  components: { FlightSearchDescription, CountdownTimer, ShowErrors },
  computed: {
    errors() {
      return store.state.errors;
    },
    descriptions() {
      return this.getAllFlightDescriptions();
    }
  },
  mounted() {
    const step = this.getStepNumberByPath("/booking/passengers");
    if (store.state.active !== step) {
      store.commit("setActiveStep", step);
    }
		this.loadPassengerFields();
		this.clearAllStudentSeniorSelections();
  }
};
</script>
